import { Component, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { HelpersService } from '@base/shared/services';
import { AnalyticsService } from './shared/services';
//import { HelpersService , HeaderService, MainSidebarService} from '@base/shared/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class EyrusAppComponent implements OnInit {

  // public sidebarOpened = false;
  // public panelToggle = false;

  constructor(
    // private headerService: HeaderService,
    // private mainSidebarService: MainSidebarService,
    private helpers: HelpersService,
    private swUpdate: SwUpdate,
    private analytics: AnalyticsService
  ) {
    this.helpers.bootstrapLang();
  }

  ngOnInit() {

    if (this.swUpdate.isEnabled)
      this.swUpdateListener();

    // Start analytics tracking
    const _interval = setInterval(() => {
      if (window['ga']) {
        this.analytics.init();
        clearInterval(_interval);
      }
    });

    // this.headerService.panelOpen.subscribe(() => {
    //   this.sidebarOpened = !this.sidebarOpened;
    // });

    // this.headerService.panelClose.subscribe(() => {
    //   this.sidebarOpened = !this.sidebarOpened;
    // });


    // this.mainSidebarService.toggleSidebarCollapsed.subscribe(() => {
    //   this.panelToggle = !this.panelToggle;
    // });

  }

  /**
   * Listen for service worker updates
   */
  private swUpdateListener() {
    this.swUpdate.available.subscribe(() => {
      if (confirm('New Version available. Load new version?')) {
        window.location.reload();
      }
    });
  }
}
